import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { useIsDown } from '../responsive';

/** Utility hook that keeps track of whether a component is in mobile view
 * wherever it is called based on window or containing element width.
 * @param mobileBreakpoint optional point at which to break to mobile
 *  view. Defaults to the theme mobile breakpoint.
 *
 * @param mobileBreakpointContainerRef defaults to the browser window's inner
 * width, otherwise you can specify any ref element's width to check against.
 */
export function useConvertToMobile(mobileBreakpoint, mobileBreakpointContainerRef) {
  var _useState = useState(mobileBreakpoint === true),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var isMobileBp = useIsDown('sm');
  useEffect(function () {
    if (mobileBreakpoint !== true) {
      var convertToMobile = function convertToMobile() {
        var width = window.innerWidth;
        if (mobileBreakpointContainerRef != null && mobileBreakpointContainerRef.current) {
          width = mobileBreakpointContainerRef.current.offsetWidth;
        }
        if (mobileBreakpoint === undefined && isMobileBp || mobileBreakpoint !== undefined && width <= mobileBreakpoint) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      };
      window.addEventListener('resize', convertToMobile);
      convertToMobile();
      return function () {
        window.removeEventListener('resize', convertToMobile);
      };
    }
  }, [mobileBreakpoint, isMobileBp, mobileBreakpointContainerRef]);
  return isMobile;
}